//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import _ from 'underscore'
export default {
  props: {
    visible: {
      default: false
    },
    initialForm: {
      default: () => ({})
    }
  },
  data: function () {
    return {
      currentVisible: this.visible,
      loading: false,
      form: _.extend({
        address: '',
        contactName: '',
        contactPhone: '',
        name: '',
        dStaffPhone: '',
        dealerAdminStatus: 1,
        dStaffId: ''
      }, this.initialForm),
      rules: {},
      options: [{
          value: 1,
          label: '允许登录'
        }, {
          value: 0,
          label: '不允许登录'
        }
      ],
    }
  },
  watch: {
    visible: {
      handler (val) {
        this.currentVisible = val
      },
      immediate: true
    }
  },
  methods: {
    handleFormSubmit () {
      this.$refs.form.validate((valid) => {
        if (valid) {
          let data = _.extend({}, _.omit(this.form), _.pick(this.initialForm, 'dealerId'))
          this.loading = true
          data.phone = data.dStaffPhone
          this.$axios.post('/mtea/store/admin/dealer/update', data).then(res => {
            this.$emit('submit', this.form)
            this.$refs.form.resetFields()
            this.$emit('update:visible', false)
            this.$notify.success({
              title: '系统提示',
              message: '操作成功'
            })
          }).finally(() => {
            this.loading = false
          })
        } else {
          this.$notify.error({
            title: '错误',
            message: '表单校验失败'
          })
          return false
        }
      })
    },
    handleOpen () {
      this.form = _.extend(this.form, this.initialForm)
    },
    handleClose(){
      _.extend(this, _.pick(this.$options.data(), 'form'))
    },
    deletePwd(dStaffId){
      let data = _.extend({}, {dStaffId: dStaffId})
      this.$axios.get('/mtea/store/admin/dealer/resetPassword', { params: data }).then(() => {
        this.$notify.success({
          title: '系统提示',
          message: '重置成功'
        })
      })
    }
  }
}
